import { WelcomeGuideComponent } from 'app/welcome/guide/guide.component';
import { Component } from '@angular/core';

import { UILensService } from 'app/ui/lens/lens.service';
import { UserSettingsService } from 'app/user/user-settings.service';

@Component({
  selector: 'welcome-capture',
  templateUrl: 'capture.component.html',
  styleUrls: ['capture.component.scss']
})
export class WelcomeCaptureComponent {

  constructor(private _uiLensService: UILensService,
    private _userSettings: UserSettingsService) {
  }

  next(): void {
    this._uiLensService.open(WelcomeGuideComponent, 'guide');
  }

  skip(): void {
    this._userSettings.welcomeTraining = true;
    this._uiLensService.close();
  }
}
